import React from "react"
import { Dialog, FlatButton, CircularProgress } from "material-ui"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import ChooseHierarchyJobPhaseChipForPunch from "../hierarchy/choose_hierarchy/ChooseHierarchyJobPhaseChipForPunch"
import EmployeeChip from "../employee/EmployeeChip"
import autobind from "class-autobind"
import moment from "moment-timezone"
import * as utils from "../../helpers/utils"
import * as  api from "../../api"
import { IJobDocument, IJobPhase, IEquipmentDocument, IDate, IObjectTimecardDocument, IPosition, IPunchBundle, IUIUser } from "../../models"
import * as punchHelper from "../../helpers/punchHelper"
import * as userHelper from "../../helpers/userHelper"
import AppStateStore from "../../stores/AppStateStore"
import Position_PayType_PayClass_Selector from "../position_paytype_payclass_selector/Position_PayType_PayClass_Selector"
import PunchDateTimeSelector from "./PunchDateTimeSelector"
import * as timeHelper from "../../helpers/timeHelper"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"

interface IProps {
    pairedPunchId: string
    equipment: IEquipmentDocument
    timecard: IObjectTimecardDocument
    date: IDate
    open: boolean
    defaultEmployeeId: string
    defaultHierarchyId: string
    defaultShiftId: string
    defaultAddJobId: string
    defaultAddPhaseId: string
    defaultPositionId: string
    defaultPayClassId: string
    defaultAddPunchPayTypeId: string
    isPunchIn: boolean
    onRequestClose(): void
    addPunch(employeeId: string, punchBundle: IPunchBundle): void
}
interface IState {
    hour: number
    minute: number
    date: any
    hierarchyLevelId: string
    errorHierarchy: string
    job: IJobDocument
    phase: IJobPhase
    loadEmployee: boolean
    employee: IUIUser
    existAvatarForEmployeeChip: boolean
    loadingPositions: boolean
    positionId: string
    punchPosition: IPosition
    errorPunchPosition: string
    selectedPayClassId: string
    selectedPayTypeId: string
    errorSelectedPayTypeId: string
    validHierarchyForEmployee: boolean
    disablePuncheMessageByDefinition: string
    hierarchyLevelIntentionalChanged: boolean
}

export default class AddPunchDialogForEquipment extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const _moment = moment()
        this.state = {
            hour: _moment.hour(),
            minute: _moment.minute(),
            date: props.date ? timeHelper.keepConvertUTCToLocal(props.date) : null,
            hierarchyLevelId: props.defaultHierarchyId ? props.defaultHierarchyId : null,
            errorHierarchy: null,
            job: null,
            phase: null,
            loadEmployee: !props.isPunchIn && props.defaultEmployeeId ? true : false,
            employee: null,
            existAvatarForEmployeeChip: false,
            loadingPositions: false,
            positionId: props.defaultPositionId,
            punchPosition: null,
            errorPunchPosition: null,
            selectedPayClassId: props.defaultPayClassId ? props.defaultPayClassId : null,
            selectedPayTypeId: props.defaultAddPunchPayTypeId ? props.defaultAddPunchPayTypeId : null,
            errorSelectedPayTypeId: null,
            validHierarchyForEmployee: true,
            disablePuncheMessageByDefinition: "",
            hierarchyLevelIntentionalChanged: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.props.defaultEmployeeId ?
            api.getUIUser(this.props.defaultEmployeeId).then(result => {
                const employee = result.data as IUIUser
                this.setState({
                    loadEmployee: false,
                    employee,
                    existAvatarForEmployeeChip: employee.ProfileImageS3Url ? true : false
                }, () => {
                    this.getDefaultJobPhase()
                })
            }) :
            this.getDefaultJobPhase()

        document.addEventListener("keydown", this.handleReturnKey, false)
    }

    getDefaultJobPhase() {
        const defaultAddJobId = this.props.defaultAddJobId ?
            this.props.defaultAddJobId :
            this.state.employee && this.state.employee.DefaultJobId ?
                this.state.employee.DefaultJobId :
                null
        const defaultAddPhaseId = this.props.defaultAddPhaseId ?
            this.props.defaultAddPhaseId :
            this.state.employee && this.state.employee.DefaultPhaseId ?
                this.state.employee.DefaultPhaseId :
                null
        defaultAddJobId &&
            api.getJob(defaultAddJobId).then(res => {
                const job: IJobDocument = res.data
                this.setState({
                    job,
                    phase: defaultAddPhaseId ? job.Phases.find(item => item.Id === defaultAddPhaseId) : null
                })
            })
    }

    handleReturnKey(e) {
        if (e.keyCode === 13) {
            this.handleRequestSave()
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleReturnKey, false)
    }

    handleRequestClose() {
        this.props.onRequestClose()
    }

    async handleRequestSave() {
        if (!this.checkValidate()) return

        const userId = this.state.employee ? this.state.employee.Id : null
        const timezoneId = await timeHelper.getIANATimezoneNameFromHierarchyJobId(this.state.hierarchyLevelId, this.state.job ? this.state.job.Id : null)
        const punch = {
            Id: utils.guid(),
            UserId: userId,
            OwnerUserId: AuthenticationStore.getLoggedInUser().Id,
            AccountId: this.props.timecard.AccountId,
            DateTime: timeHelper.getTimezoneTranslatedDateTime(this.state.date, this.state.minute, this.state.hour, timezoneId),
            Offline: false,
            MetaData: {
                UploadDateTime: moment().format(),
                Latitude: 0,
                Longitude: 0,
                Accuracy: 0,
                BiometricScore: 0
            },
            ShiftId: this.props.defaultShiftId,
            PayTypeId: this.state.selectedPayTypeId,
            PayClassId: this.state.selectedPayClassId,
            EquipmentId: this.props.equipment.Id,
            PositionId: this.state.positionId,
            HierarchyItemId: this.state.hierarchyLevelId,
            JobId: this.state.job && this.state.job.Id,
            JobName: this.state.job && this.state.job.Name,
            JobCostCode: this.state.job && this.state.job.CostCode,
            PhaseId: this.state.job && this.state.phase && this.state.phase.Id,
            PhaseName: this.state.job && this.state.phase && this.state.phase.Name,
            PhaseCostCode: this.state.job && this.state.phase && this.state.phase.CostCode
        }

        const disablePuncheMessageByDefinition = punchHelper.getDisablePuncheMessageByDefinition(punch.HierarchyItemId, punch.JobId, punch.PhaseId)
        this.props.isPunchIn && disablePuncheMessageByDefinition ?
            AppStateStore.setProgressSnackbarContent(disablePuncheMessageByDefinition) :
            this.props.addPunch(userId, {
                Punch: punch,
                PunchPosition: AccountStore.getPayClassEnabled() && this.state.punchPosition ?
                    { Position: this.state.punchPosition } :
                    null
            })
    }

    checkValidate() {
        let validate = true
        if (this.state.errorHierarchy) validate = false
        if (this.props.isPunchIn && !this.state.validHierarchyForEmployee) validate = false
        if (this.state.employee && this.state.errorSelectedPayTypeId) validate = false
        if (this.state.errorPunchPosition) validate = false
        return validate
    }

    setEmployee(employee: IUIUser) {
        this.setState({
            employee,
            existAvatarForEmployeeChip: employee && employee.ProfileImageS3Url ? true : false,
        }, () =>
            this.checkValidateEmployeeAndHierarchy()
        )
    }

    checkValidateEmployeeAndHierarchy() {
        if (!this.state.employee) return
        const employeeAccessHierarchyIds = userHelper.getEmployeeAccessHierarchyIds(this.state.employee)
        const permissionValidate = employeeAccessHierarchyIds.includes(this.state.hierarchyLevelId)
        this.setState({ validHierarchyForEmployee: permissionValidate })
    }

    render() {
        const { existAvatarForEmployeeChip, employee, loadingPositions } = this.state
        const { isPunchIn } = this.props
        const standardActions = (
            <div>
                <FlatButton label={strings.CANCEL} secondary onClick={this.handleRequestClose} />
                <FlatButton label={strings.Add_Punch.toUpperCase()} primary disabled={loadingPositions} onClick={this.handleRequestSave} />
            </div>
        )
        return (
            <Dialog
                actionsContainerClassName="AddPunchDialog"
                open={this.props.open}
                title={strings.Add_Punch.toUpperCase() + " - " + this.props.equipment.Name + " - " + this.props.equipment.ExternalId}
                actions={standardActions}
            >
                {this.state.loadEmployee ?
                    <CircularProgress /> :
                    <div>
                        {(this.props.isPunchIn || this.props.defaultEmployeeId) &&
                            <div>
                                <i
                                    className="fa fa-user"
                                    style={
                                        employee
                                            ? existAvatarForEmployeeChip
                                                ? isPunchIn
                                                    ? { marginRight: 10, position: "relative", top: -14 }
                                                    : { marginRight: 10, position: "relative", top: -15 }
                                                : isPunchIn
                                                    ? { marginRight: 10, position: "relative" }
                                                    : { marginRight: 10, position: "relative", top: 6 }
                                            : { marginRight: 10 }
                                    }
                                />
                                <EmployeeChip
                                    errEmployee={false}
                                    setEmployee={this.setEmployee}
                                    filterByLevel
                                    readonly={!this.props.isPunchIn}
                                    selectedEmployee={this.state.employee as IUIUser}
                                />
                            </div>
                        }
                        <ChooseHierarchyJobPhaseChipForPunch
                            byEquipment
                            hideIcon={false}
                            readonly={!this.props.isPunchIn}
                            hierarchyChipLabel={strings.ChoosePunchHierarchy}
                            jobChipLabel={checkJobFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Choose_Job}
                            phaseChipLabel={ punchHelper.checkPhaseFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Choose_Phase}
                            employee={this.state.employee}
                            errorHierarchyChipText={this.state.employee && this.state.validHierarchyForEmployee === false && strings.Invalid_for_employee}
                            punchHierarchyItemId={this.state.hierarchyLevelId}
                            jobId={this.state.job ? this.state.job.Id : null}
                            phaseId={this.state.phase ? this.state.phase.Id : null}
                            handleSelectHierarchyJobPhase={(hierarchyLevelId, errorHierarchy, job, phase, intentionalChanged) =>
                                this.setState({
                                    hierarchyLevelId,
                                    errorHierarchy,
                                    job,
                                    phase,
                                    hierarchyLevelIntentionalChanged: intentionalChanged ? true : this.state.hierarchyLevelIntentionalChanged
                                }, () =>
                                    this.checkValidateEmployeeAndHierarchy()
                                )
                            }
                            searchJobByEmpPermission
                        />
                        <Position_PayType_PayClass_Selector
                            readonly={!this.props.isPunchIn}
                            date={this.state.date}
                            employee={this.state.employee}
                            hierarchyId={this.state.hierarchyLevelId}
                            shiftId={this.props.defaultShiftId}
                            jobId={this.state.job ? this.state.job.Id : null}
                            phaseId={this.state.phase ? this.state.phase.Id : null}
                            selectedPositionId={this.state.positionId}
                            selectedPayTypeId={this.state.selectedPayTypeId}
                            selectedPayClassId={this.state.selectedPayClassId}
                            keepPropsPayClassId_PayTypeId={!this.props.isPunchIn}
                            handleSelectPosition={(position, errorPunchPosition) => this.setState({ punchPosition: position, positionId: position ? position.Id : null, errorPunchPosition })}
                            handleSelectPayType={(selectedPayTypeId, errorSelectedPayTypeId) => this.setState({ selectedPayTypeId, errorSelectedPayTypeId })}
                            handleSelectPayClass={selectedPayClassId => this.setState({ selectedPayClassId })}
                            handleLoadingPositions={loadingPositions => this.setState({ loadingPositions })}
                            referencePunchPositionDocumentId={this.props.pairedPunchId}
                            hierarchyLevelIntentionalChanged={this.state.hierarchyLevelIntentionalChanged}
                        />
                        <PunchDateTimeSelector
                            hierarchyId={this.state.hierarchyLevelId}
                            jobId={this.state.job ? this.state.job.Id : null}
                            date={this.state.date}
                            hour={this.state.hour}
                            minute={this.state.minute}
                            handleChange={(date, hour, minute) => this.setState({ date, hour, minute })}
                        />
                    </div>
                }
            </Dialog>
        )
    }
}
